import React, { useContext, useState } from "react";
import { detect } from "detect-browser";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { isEmail, isRequired } from "../../validators";
import MaterialTheme from "../../core/MaterialTheme";
import HtmlForm from "../../core/HtmlForm";
import TextInput from "../../core/form/TextInput";
import Separator from "../../core/Separator";
import FlexRow from "../../core/FlexRow";
import withTranslation from "../../core/withTranslation";
import WhitelabelContext from "../../components/WhitelabelContext";
import { useForm, useService } from "../../hooks";
import { login } from "../../services/authenticationService";
import { cleanEntities } from "../../actions/entity";
import AuthMessage from "../../core/AuthMessage";
import ButtonV2 from "../../core/ButtonV2";

function LoginForm(props) {
  const history = useHistory();
  const [error, setError] = useState();
  const whitelabelContext = useContext(WhitelabelContext);
  const deviceInfo = detect();
  const dispatch = useDispatch();

  const [isSubmitting, start] = useService(login, {
    onData: (data) => {
      sessionStorage.setItem("id", data.id);
      history.replace("/");
    },
    onError: (error) => {
      let message = error.message;
      if (error.code && props.getTranslation(`login.${error.code}`)) {
        message = props.getTranslation(`login.${error.code}`);
      }
      setError(message);
    },
  });

  const { getValue, setValue, getError, submit, isSubmitted } = useForm({
    initialValues: {
      role: "STUDENT",
      distributor: whitelabelContext.distributor,
      company: whitelabelContext.company,
      deviceInfo: {
        browser: `${deviceInfo.name}_${deviceInfo.version}`,
        os: deviceInfo.os,
        screenSize: `${window.screen.width}_x_${window.screen.height}`,
        internetSpeed: "N/A",
      },
    },
    validations: {
      email: [isRequired, isEmail],
      password: [isRequired],
    },
    onSubmit: (values) => {
      dispatch(cleanEntities());
      setError(null);
      start(values);
    },
  });

  return (
    <>
      <MaterialTheme>
        <HtmlForm onSubmit={submit}>
          <TextInput
            disabled={isSubmitting}
            onChange={(value) => setValue("email", value.replace(/\s+/g, ""))}
            value={getValue("email")}
            error={isSubmitted() && getError("email")}
            label={props.getTranslation("login.email")}
            fullWidth
            autoComplete={false}
          />
          <Separator />
          <TextInput
            disabled={isSubmitting}
            onChange={(value) => setValue("password", value)}
            value={getValue("password")}
            error={isSubmitted() && getError("password")}
            label={props.getTranslation("login.password")}
            fullWidth
            type="password"
            autoComplete={false}
          />
          <Separator size="lg" />
          <Separator size="lg" />
          <FlexRow justifyContent="center" alignItems="center">
            <ButtonV2
              size="md"
              intent="wl-primary"
              labelKey="login.enter"
              isDisabled={isSubmitting}
              buttonType="submit"
              fullWidth
            />
          </FlexRow>
        </HtmlForm>
      </MaterialTheme>
      <Separator size="md" />
      <AuthMessage isOpen={!!error} message={error} type="error" />
    </>
  );
}

export default withTranslation(LoginForm);
